import { LabelingBoxContext } from '../LabelingBoxProvider';

const useLabelingBoxContext = () => LabelingBoxContext.hook();

export default useLabelingBoxContext;
